import type { PaginatedGiftCardStockDto } from "common/models/api/models/GiftCardStock";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApiV2 } from "../api/giftcardsApiV2";

export interface UseGetGiftCardStockParams {
    page: number;
    pageSize?: number;
    query?: string;
}

export default function useGetGiftCardStock(
    { page, pageSize = 10, query }: UseGetGiftCardStockParams,
    options?: UseQueryOptions<PaginatedGiftCardStockDto, unknown, PaginatedGiftCardStockDto, (Queries | number | string | undefined)[]>,
): UseQueryResult<PaginatedGiftCardStockDto> {
    return useQuery(
        [Queries.GIFTCARDS_STOCK_FIND_ALL, page, pageSize, query],
        async () => {
            const res = await giftcardsApiV2.getGiftCardStock({ page, pageSize, query });
            return res.data;
        },
        { ...options },
    );
}
